module.exports = __webpack_public_path__ + "static/img/en_logoFooter.214a05b9.jpg";